import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { confirmSignUp } from "../../Auth/auth-service";
import { Box, Button, TextField, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";

const ConfirmUserPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [confirmationCode, setConfirmationCode] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await confirmSignUp(email, confirmationCode);
      alert("Account confirmed successfully!\nSign in on next page.");
      navigate("/login");
    } catch (error) {
      alert(`Failed to confirm account: ${error}`);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
        position: "relative", 
        minHeight: "100vh",
        backgroundColor: "#FFFFFF", 
        overflow: "hidden", 
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.8)", 
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            boxShadow: "inset 0 0 50px rgba(0, 0, 0, 0.5)", 
            pointerEvents: "none", 
          },
        }}
      />
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          fontWeight: "bold",
          color: "#222831",
          display: "flex",
          alignItems: "center",
          position: "relative",
          zIndex: 1, 
          fontFamily:"Poppins",
        }}
      >
        <CheckCircle sx={{ color: "#00ADB5", marginRight: 1 }} />
        Account Confirmation
      </Typography>
      <Typography
        variant="body1"
        align="center"
        gutterBottom
        sx={{ color: "#393E46", position: "relative", zIndex: 1,fontFamily:"Poppins", }}
      >
        Please confirm your account by entering the confirmation code sent to{" "}
        <b>{email}</b>.
      </Typography>
      <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: 400 }}>
        <TextField
          type="text"
          value={confirmationCode}
          onChange={(e) => setConfirmationCode(e.target.value)}
          aria-label="Confirmation Code"
          placeholder="Confirmation Code"
          required
          fullWidth
          margin="normal"
          sx={{
            fontFamily:"Poppins",
            "& .MuiInputBase-root": {
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "inset 0 0 5px rgba(0, 0, 0, 0.2)",
            },
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: "#00ADB5",
              },
            },
          }}
        />
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              fontFamily:"Poppins",
              backgroundColor: "#00ADB5",
              color: "#FFF",
              "&:hover": {
                backgroundColor: "#007B7F",
              },
              borderRadius: "8px",
              padding: "10px 20px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)", 
            }}
            fullWidth
          >
            Confirm Account
          </Button>
        </Box>
      </form>
      <Box sx={{ mt: 2 }}>
        <Typography variant="body2" align="center" sx={{ color: "#393E46", position: "relative", zIndex: 1,fontFamily:"Poppins", }}>
          Already have an account?
          <Link to="/login" style={{ marginLeft: "4px", color: "#4A8BDF" }}>
            Log in
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default ConfirmUserPage;
